/**
 * Utility functions for formatting data for display
 */

/**
 * Convert boolean-like values to Yes/No strings
 * @param {any} value - Value to check
 * @returns {string} "Yes", "No", or "N/A"
 */
export const renderYesNo = (value) => {
  if (value === true || value === "true" || value === "yes" || value === "Yes" || value === 1 || value === "1") {
    return "Yes";
  }
  if (value === false || value === "false" || value === "no" || value === "No" || value === 0 || value === "0") {
    return "No";
  }
  return "N/A";
};

/**
 * Format a date for display
 * @param {string} dateStr - Date string to format
 * @param {boolean} includeTime - Whether to include time in the output
 * @returns {string} Formatted date string or "N/A" if invalid
 */
export const formatDate = (dateStr, includeTime = false) => {
  if (!dateStr) return "N/A";
  
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr; // Return original if invalid
    
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      ...(includeTime && { hour: '2-digit', minute: '2-digit' })
    };
    
    return date.toLocaleDateString('en-US', options);
  } catch (e) {
    return dateStr; // Return original on error
  }
};